import { type Ref, inject } from 'vue';

import { i18n } from '@/assets/translations';

import { getLocale } from '@/helpers';
import { useLocaleStore } from '@/stores';

export const useLocale = () => {
  const { locale } = i18n.global;
  const localeStore = useLocaleStore();

  const initialLocale: string = localeStore.locale || getLocale();

  const setLocale = (newLocale: string) => {
    const $vueform = inject('$vueform') as Ref<{ i18n: { locale: string } }>;

    localeStore.setLocale(newLocale);
    locale.value = newLocale as typeof locale.value;
    if ($vueform?.value?.i18n) {
      $vueform.value.i18n.locale = newLocale;
    }
  };

  return { locale, initialLocale, setLocale };
};
